// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/contact.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


svg:not(:root).svg-inline--fa {
  overflow: visible;
}
.svg-inline--fa.fa-w-14 {
  width: 0.875em;
}



.contact-page-banner {
  height: 420px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center / cover no-repeat;
  background-position: 100% 50%;
  margin-top: -15px;
}

.contact-clean h2 {
  margin-top: 5px;
  font-weight: 700;
  font-size: 28px;
  /* margin-bottom: 36px; */
  color: inherit;
}

.contact-clean form .form-control {
  background: #fff;
  border-radius: 2px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);
  outline: 0;
  color: inherit;
  padding-left: 12px;
  height: 42px;
}
.fade:not(.show) {
  opacity: 0;
}
.fade {
  transition: opacity 0.15s linear;
}
.pd-y-50 {
  padding: 50px 0px;
}
.width-80per {
  width: 80% !important;
  margin: auto;
}

h1 {
  font-size: 2.5rem;
}
.focus-input-label .floating-label label {
  font-size: 14px;
  color: #000;
  font-weight: 500;
  position: absolute;
  top: -3px;
  left: 0px;
  
  /* text-transform: capitalize; */
}
textarea {
  height: 100px !important;
}
textarea {
  overflow: auto;
  resize: vertical;
}
.mt-5 {
  margin-top: 3rem !important;
}
.mb-4 {
  margin-bottom: 1.5rem !important;
}
.btn-block {
  display: block;
  width: 100%;
}
.contact-clean form .btn {
  padding: 16px 32px;
  border: none;
  background: 0 0;
  box-shadow: none;
  text-shadow: none;
  opacity: 0.9;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.4px;
  line-height: 1;
  outline: 0 !important;
}
.contact-clean .form-group:last-child {
  margin-bottom: 5px;
}
.contact-clean form .btn-primary {
  background-color: #e43126 !important;
  margin-top: 15px;
  color: #fff;
}






.focus-input-label .floating-label {
  position: relative;
  margin-bottom: 18px;
  padding-top: 20px;
}
.focus-input-label .floating-label input.form-control {
  font-size: 15px;
  padding: 10px 10px;
  height: 43px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  min-width: initial;
  box-sizing: border-box;
  /* -webkit-transition: all 0.3s linear; */
  transition: all 0.3s linear;
  color: #000;
  font-weight: 400;
  -webkit-appearance: none;
  appearance: "";
  width: 100%;

  border-radius: 6px;
  outline: 0px;
  /* box-shadow: none; */
}


.focus-input-label .floating-label {
  position: relative;
  margin-bottom: 18px;
  padding-top: 20px;
}
.focus-input-label .floating-label label {
  font-size: 14px;
  color: #000;
  font-weight: 500;
  position: absolute;
  top: -3px;
  left: 0px;
  
  /* text-transform: capitalize; */
}
.focus-input-label .floating-label {
  position: relative;
  margin-bottom: 18px;
  padding-top: 20px;
}



.contact-clean form .btn {
  padding: 16px 32px;
  border: none;
  background: 0 0;
  box-shadow: none;
  text-shadow: none;
  opacity: 0.9;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.4px;
  line-height: 1;
  outline: 0 !important;
}
.contact-clean form .btn-primary {
  background-color: #e43126 !important;
  margin-top: 15px;
  color: #fff;
}


.contact-clean .form-group:last-child {
  margin-bottom: 5px;
}
.contact-clean form .form-control {
  background: #fff;
  border-radius: 2px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);
  outline: 0;
  color: inherit;
  padding-left: 12px;
  /* height: 42px; */
}
.contact-clean form textarea.form-control {
  min-height: 100px;
  max-height: 260px;
  padding-top: 10px;
  resize: vertical;
}


.contact-clean form {
  max-width: 600px;
  width: 90%;
  margin: 0 auto;
  padding: 40px;
  border-radius: 4px;
  color: #505e6c;
}
.contact-clean {
  padding: 40px 0;
  background-color: #f0f0f0;
}
.contact-page-banner-text h1 {
  color: #ffffff;
  font-size: 56px;
  font-weight: bold;
  font-family: Roboto, sans-serif;
  text-align: center;
}
.contact-page-banner-text {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  flex-direction: column;
  width: 50%;
  margin: auto;
}
.contact-page-banner-layer {
  height: inherit;
  min-height: initial;
  width: 100%;
  position: absolute;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}



.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  /* overflow: visible; */
  vertical-align: -0.125em;
}





.article-list.contact-feedback {
  padding-bottom: 40px;
}



.article-list.contact-feedback .item {
  padding-top: 50px;
  text-align: center;
}


.article-list.contact-feedback .item {
  padding-top: 50px;
  text-align: center;
}

.fa-comment-o:before {
  content: "\\f0e5";
}
.article-list.contact-feedback .item .name {
  font-weight: 700;
  font-size: 16px;
  margin-top: 20px;
  color: #e43126;

}
.article-list.contact-feedback .item .description {
  font-size: 14px;
  margin-top: 15px;
  margin-bottom: 0;
  color: #7d8285;

}
.article-list.contact-feedback .item {
  padding-top: 50px;
  text-align: center;
}


/*-------------- modal styles------------ */

.modal.new_modal_pop .modal-content h6 {
  color: #505050;
  text-align: center;
  font-size: 20px;
  position: relative;
  margin-bottom: 25px;
}

.modal.new_modal_pop .modal-content .only_close {
  height: 30px;
}

.modal.new_modal_pop .modal-content {
  background: #ffffff;
  border-radius: 15px;
}

.modal.new_modal_pop .pointer.close {
  position: absolute;
  top: 10px;
  right: 15px;

  line-height: 20px;
 
  
  font-size: 32px !important;
  opacity: 1;
}

.modal.new_modal_pop .padding-x-50 {
  padding: 0px 50px;
}

.modal.new_modal_pop .btn.theme-btn {
  
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: 14px;
  padding: 8px 15px;
}
.modal.new_modal_pop .form-control {
  border: solid 1px rgba(0, 0, 0, 0.2);
  outline: 0px;
  box-shadow: none !important;
  border-radius: 6px;
  margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./app/pages/DestinationServicesStatic/pricing/contact.css"],"names":[],"mappings":";;;AAGA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;;;;AAIA;EACE,aAAa;EACb,4EAA2E;EAC3E,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,SAAS;;EAET,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;;;;;;AAOA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,yCAAyC;EACzC,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,WAAW;;EAEX,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,SAAS;;EAET,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;;;AAIA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;;;AAIA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,wBAAwB;AAC1B;;;;;;AAMA;EACE,oBAAoB;AACtB;;;;AAIA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;;AAEhB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;;AAEhB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA,2CAA2C;;AAE3C;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;;EAEX,iBAAiB;;;EAGjB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["\n\n\nsvg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n\n\n\n.contact-page-banner {\n  height: 420px;\n  background: url(/public/assets/images/contact.jpg) center / cover no-repeat;\n  background-position: 100% 50%;\n  margin-top: -15px;\n}\n\n.contact-clean h2 {\n  margin-top: 5px;\n  font-weight: 700;\n  font-size: 28px;\n  /* margin-bottom: 36px; */\n  color: inherit;\n}\n\n.contact-clean form .form-control {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);\n  outline: 0;\n  color: inherit;\n  padding-left: 12px;\n  height: 42px;\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n.fade {\n  transition: opacity 0.15s linear;\n}\n.pd-y-50 {\n  padding: 50px 0px;\n}\n.width-80per {\n  width: 80% !important;\n  margin: auto;\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n.focus-input-label .floating-label label {\n  font-size: 14px;\n  color: #000;\n  font-weight: 500;\n  position: absolute;\n  top: -3px;\n  left: 0px;\n  \n  /* text-transform: capitalize; */\n}\ntextarea {\n  height: 100px !important;\n}\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n.mt-5 {\n  margin-top: 3rem !important;\n}\n.mb-4 {\n  margin-bottom: 1.5rem !important;\n}\n.btn-block {\n  display: block;\n  width: 100%;\n}\n.contact-clean form .btn {\n  padding: 16px 32px;\n  border: none;\n  background: 0 0;\n  box-shadow: none;\n  text-shadow: none;\n  opacity: 0.9;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.4px;\n  line-height: 1;\n  outline: 0 !important;\n}\n.contact-clean .form-group:last-child {\n  margin-bottom: 5px;\n}\n.contact-clean form .btn-primary {\n  background-color: #e43126 !important;\n  margin-top: 15px;\n  color: #fff;\n}\n\n\n\n\n\n\n.focus-input-label .floating-label {\n  position: relative;\n  margin-bottom: 18px;\n  padding-top: 20px;\n}\n.focus-input-label .floating-label input.form-control {\n  font-size: 15px;\n  padding: 10px 10px;\n  height: 43px;\n  border: solid 1px rgba(0, 0, 0, 0.2);\n  min-width: initial;\n  box-sizing: border-box;\n  /* -webkit-transition: all 0.3s linear; */\n  transition: all 0.3s linear;\n  color: #000;\n  font-weight: 400;\n  -webkit-appearance: none;\n  appearance: \"\";\n  width: 100%;\n\n  border-radius: 6px;\n  outline: 0px;\n  /* box-shadow: none; */\n}\n\n\n.focus-input-label .floating-label {\n  position: relative;\n  margin-bottom: 18px;\n  padding-top: 20px;\n}\n.focus-input-label .floating-label label {\n  font-size: 14px;\n  color: #000;\n  font-weight: 500;\n  position: absolute;\n  top: -3px;\n  left: 0px;\n  \n  /* text-transform: capitalize; */\n}\n.focus-input-label .floating-label {\n  position: relative;\n  margin-bottom: 18px;\n  padding-top: 20px;\n}\n\n\n\n.contact-clean form .btn {\n  padding: 16px 32px;\n  border: none;\n  background: 0 0;\n  box-shadow: none;\n  text-shadow: none;\n  opacity: 0.9;\n  text-transform: uppercase;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.4px;\n  line-height: 1;\n  outline: 0 !important;\n}\n.contact-clean form .btn-primary {\n  background-color: #e43126 !important;\n  margin-top: 15px;\n  color: #fff;\n}\n\n\n.contact-clean .form-group:last-child {\n  margin-bottom: 5px;\n}\n.contact-clean form .form-control {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.05);\n  outline: 0;\n  color: inherit;\n  padding-left: 12px;\n  /* height: 42px; */\n}\n.contact-clean form textarea.form-control {\n  min-height: 100px;\n  max-height: 260px;\n  padding-top: 10px;\n  resize: vertical;\n}\n\n\n.contact-clean form {\n  max-width: 600px;\n  width: 90%;\n  margin: 0 auto;\n  padding: 40px;\n  border-radius: 4px;\n  color: #505e6c;\n}\n.contact-clean {\n  padding: 40px 0;\n  background-color: #f0f0f0;\n}\n.contact-page-banner-text h1 {\n  color: #ffffff;\n  font-size: 56px;\n  font-weight: bold;\n  font-family: Roboto, sans-serif;\n  text-align: center;\n}\n.contact-page-banner-text {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  flex-direction: column;\n  width: 50%;\n  margin: auto;\n}\n.contact-page-banner-layer {\n  height: inherit;\n  min-height: initial;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  /* overflow: visible; */\n  vertical-align: -0.125em;\n}\n\n\n\n\n\n.article-list.contact-feedback {\n  padding-bottom: 40px;\n}\n\n\n\n.article-list.contact-feedback .item {\n  padding-top: 50px;\n  text-align: center;\n}\n\n\n.article-list.contact-feedback .item {\n  padding-top: 50px;\n  text-align: center;\n}\n\n.fa-comment-o:before {\n  content: \"\\f0e5\";\n}\n.article-list.contact-feedback .item .name {\n  font-weight: 700;\n  font-size: 16px;\n  margin-top: 20px;\n  color: #e43126;\n\n}\n.article-list.contact-feedback .item .description {\n  font-size: 14px;\n  margin-top: 15px;\n  margin-bottom: 0;\n  color: #7d8285;\n\n}\n.article-list.contact-feedback .item {\n  padding-top: 50px;\n  text-align: center;\n}\n\n\n/*-------------- modal styles------------ */\n\n.modal.new_modal_pop .modal-content h6 {\n  color: #505050;\n  text-align: center;\n  font-size: 20px;\n  position: relative;\n  margin-bottom: 25px;\n}\n\n.modal.new_modal_pop .modal-content .only_close {\n  height: 30px;\n}\n\n.modal.new_modal_pop .modal-content {\n  background: #ffffff;\n  border-radius: 15px;\n}\n\n.modal.new_modal_pop .pointer.close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n\n  line-height: 20px;\n \n  \n  font-size: 32px !important;\n  opacity: 1;\n}\n\n.modal.new_modal_pop .padding-x-50 {\n  padding: 0px 50px;\n}\n\n.modal.new_modal_pop .btn.theme-btn {\n  \n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.5px;\n  line-height: 14px;\n  padding: 8px 15px;\n}\n.modal.new_modal_pop .form-control {\n  border: solid 1px rgba(0, 0, 0, 0.2);\n  outline: 0px;\n  box-shadow: none !important;\n  border-radius: 6px;\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
